var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "37px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(-2.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "24pt-Bounding-Box",
    opacity: 0,
    fillRule: "nonzero",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9999999,3.99999955 L4.99999987,3.99999955 L4.99999987,3.99999955 C3.34314987,3.99999955 1.99999987,5.34315 1.99999987,6.99999955 C1.99999987,6.99999955 1.99999987,6.99999955 1.99999987,6.99999955 L1.99999987,16.9999995 L1.99999987,16.9999995 C1.99999987,18.6568495 3.34314987,19.9999995 4.99999987,19.9999995 L18.9999999,19.9999995 L18.9999999,19.9999995 C20.6568497,19.9999995 21.9999999,18.6568495 21.9999999,16.9999995 L21.9999999,6.99999955 L21.9999999,6.99999955 C21.9999999,5.34314955 20.6568497,3.99999955 18.9999999,3.99999955 L18.9999999,3.99999955 Z M18.33,6 L12,10.75 L5.67,6 L18.33,6 Z M19,18 L4.99999996,18 L4.99999996,18 C4.44771496,18 3.99999996,17.552285 3.99999996,17 C3.99999996,17 3.99999996,17 3.99999996,17 L3.99999996,7.24999994 L11.4,12.8 L11.3999999,12.7999999 C11.5730959,12.9298219 11.7836299,12.9999999 12,12.9999999 L12,12.9999999 C12.2163698,13 12.4269038,12.929822 12.5999998,12.7999999 L20,7.24999994 L20,16.9999999 L20,16.9999999 C20,17.5522849 19.5522848,18 19,18 L19,18 Z",
    id: "Fill",
    fill: " #18a957"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSetting);
export default __webpack_public_path__ + "static/media/email-setting.611c79300d1c1ebb90d5bcee3bf70e90.svg";
export { ForwardRef as ReactComponent };